import React, { useState } from 'react';
import { FaMoon } from '@react-icons/all-files/fa/FaMoon';
import { FaSun } from '@react-icons/all-files/fa/FaSun';
import {
  applyTheme,
  getStoredTheme,
  persistTheme,
  themeLabel,
  type ThemeMode,
} from '../shared/theme/theme';

export default function ThemeToggle() {
  const [theme, setTheme] = useState<ThemeMode>(() => getStoredTheme());

  const toggleTheme = () => {
    const next: ThemeMode = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    applyTheme(next);
    persistTheme(next);
  };

  return (
    <button
      type="button"
      className="crm-theme-toggle"
      onClick={toggleTheme}
      title={`Tema ${themeLabel(theme)}. Clic para cambiar.`}
      aria-label={`Tema ${themeLabel(theme)}. Cambiar tema.`}
    >
      <span className="crm-theme-toggle-icon" aria-hidden>
        {theme === 'dark' ? <FaMoon /> : <FaSun />}
      </span>
      <span className="crm-theme-toggle-label">{themeLabel(theme)}</span>
    </button>
  );
}
